<template>
  <modal name="wordCloud.confirm"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
    @opened="opened"
    :width="520"
    :height="220"
    :classes="['custom']"
  >
    <div class="cantainer">
      <div class="content">
        <span>
            {{thing.text}}
        </span>
      </div>
      <div class="footer">
        <div v-if="thing.reset" style="backgroundColor: #f1243c; borderColor: #f1243c; color: #fff;" class="button button--primary" @click="confirm">清除所有</div>
        <div v-else class="button button--primary" style="backgroundColor: #5778fb; borderColor: #5778fb; color: #fff;" @click="confirm">确定</div>
        <div class="button button--primary" @click="cancel">取消</div>
      </div>
      <div class="close-btn" @click="hide()">
        <i class="icon-popup-close"></i>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      thing: {
        name: '',
        text: '',
      }
    }
  },
  mounted () {
    // $(this.$el).find('.v--modal-overlay')

  },
  methods: {
    beforeOpen (event) {
      this.$bus.emit('FeaturesPop_close_vue', {
        type: 3,
      });
      this.$bus.emit('wordCloud.hidePopups');
      this.thing = event.params;
    },
    opened () {
      this.$nextTick(() => {
        $(this.$el).css({
          backgroundColor: 'rgba(0, 0, 0, 0.7)'
        })
      })
    },
    hide () {
      this.$modal.hide('wordCloud.confirm')
    },
    cancel () {
      this.$bus.off('wordCloud.confirm.do');
      this.hide();
    },
    confirm () {
      this.$bus.emit('wordCloud.confirm.do', this.thing);
      this.hide();
    }
  }
}
</script>

<style lang="scss" scoped>
.cantainer {
  & * {
    color: #474261;
  }
  position: relative;
  width: 462px;
	height: 220px;
  margin: auto;
  padding-top: 48px;
	background-color: #ffffff;
	box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
	border-radius: 4px;
  text-align: center;

  & * {
    text-align: center;
  }
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  margin-bottom: 36px;
  margin-left: 24px;
  margin-right: 24px;
  line-height: 1.8;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;

  >div:nth-of-type(1) {
    margin-right: 47px;
  }
}

.button {
    width: 160px;
    height: 40px;
    border-radius: 8px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    width: 120px;
    height: 40px;
    background-color: #eaeaf6;
    border-radius: 4px;
    color: #474261;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/wordCloud/modals/confirmCloud.vue